import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { siteFromRootSiteSelector } from 'selectors/root-site';
import CustomHomePage from 'components/custom-home-page';
import SkeletonLayout from 'components/skeleton-layout';

const StandardSitePage = React.lazy(() => import('./standard-page'));

const SitePage = () => {
  const { siteSlug } = useParams();
  const { siteId, homePage } = useSelector(siteFromRootSiteSelector(siteSlug));

  return homePage ? (
    <CustomHomePage {...homePage} />
  ) : (
    <Suspense fallback={<SkeletonLayout showFooter={false} showHeader={false} />}>
      <StandardSitePage siteId={siteId} siteSlug={siteSlug} />
    </Suspense>
  );
};

export default SitePage;
